// Components
import { Loading } from "components"
import { InputSection } from "./InputSection"

// Utils
import { useDetail } from "../utils"

export function Detail(params: {
  id: string
}): JSX.Element {
  // Hooks
  const { data, isLoading } = useDetail(params.id)

  if (isLoading || !data) {
    return <Loading loading={isLoading} />
  }

  return (
    <div className="container my-5 flex flex-col gap-3">
      <InputSection data={data} />
    </div>
  )
}